import { makeStyles } from '@material-ui/core/styles';

import { colors } from './tokens';

const useStyles = makeStyles(theme => ({
  root: {
    color: colors.textPrimary,
    padding: theme.spacing(1.5, 1.5, 3),
  },
  // Empilha as linhas do dashboard com espaçamento vertical de 32px (Figma),
  // mantendo o espaçamento horizontal de 16px (spacing={2}) dentro de cada linha.
  rows: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  statusCardsWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      flexDirection: 'column',
    },
  },
  statusCardsItem: {
    flex: 1,
    minWidth: 0,
  }
}));

export default useStyles;
